import React, { useState, useMemo, useEffect } from 'react'
import axios from 'axios'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Select from 'react-select'
import countryList from 'react-select-country-list'
import { get_current_campaign_user } from '../../redux/actions/campaignActions'
import { create_submission } from '../../redux/actions/submissionActions'

import Dropper from '../../components/Dropper'

import { FaScroll, FaEye } from 'react-icons/fa'
import { ImProfile } from 'react-icons/im'
import { GiMoneyStack } from 'react-icons/gi'
import { BsPlusSquare } from 'react-icons/bs'
// import { AiFillCamera, AiOutlineCamera } from 'react-icons/ai'

import {
	TabContent,
	TabPane,
	Nav,
	NavItem,
	NavLink,
	Row,
	Col,
} from 'reactstrap'
import classnames from 'classnames'
import {
	CREATE_SUBMISSION_RESET,
	GET_CURRENT_CAMPAIGN_RESET,
} from '../../redux/types'

const UserDashboardNewSubmission = () => {
	const dispatch = useDispatch()
	const navigate = useNavigate('')

	const getCurrentCampaign = useSelector((state) => state.getCurrentCampaign)
	const { currentCampaign } = getCurrentCampaign

	const createSubmission = useSelector((state) => state.createSubmission)
	const { loading: loadingCreate, submission } = createSubmission

	const userAuth = useSelector((state) => state.userAuth)
	const { userDetail } = userAuth

	const [activeTab, setActiveTab] = useState('1')

	const [ImageArray, setImageArray] = useState([])

	const [title, setTitle] = useState('')
	const [description, setDescription] = useState('')
	const [subTitle, setSubTitle] = useState('')
	const [genre, setGenre] = useState('')
	const [video, setVideo] = useState('')
	const [category, setCategory] = useState('')
	const [rewards, setRewards] = useState('')
	const [locationArray, setLocationArray] = useState({})
	const [location, setLocation] = useState('')
	const [script, setScript] = useState('')
	const [feedback, setFeedback] = useState(null)
	const [askingAmount, setAskingAmount] = useState('')
	const [accountNumber, setAccountNumber] = useState('')
	const [accountName, setAccountName] = useState('')
	const [bank, setBank] = useState('')
	const [submissionRound, setSubmissionRound] = useState('')
	const [uploading, setUploading] = useState(false)
	const [scriptUploading, setScriptUploading] = useState(false)

	const [uploadedImage, setUploadedImage] = useState('')
	const [imageFile, setImageFile] = useState('')

	const [formD, setFormD] = useState('')
	const [val, setVal] = useState('')

	function toggle(tab) {
		if (activeTab !== tab) {
			setActiveTab(tab)
		}
	}

	const options = useMemo(() => countryList().getData(), [])

	const changeHandler = (locationArray) => {
		setLocationArray(locationArray)

		setLocation(locationArray.label)
	}

	const getBase64 = (file) => {
		return new Promise((resolve) => {
			let baseURL = ''
			let reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onload = () => {
				// Make a fileInfo Object
				baseURL = reader.result
				resolve(baseURL)
			}
		})
	}

	const _setFile1 = (file) => {
		getBase64(file)
			.then((result) => {
				file['base64'] = result
				console.log('File Is', file)
				let split = file.base64.split(',')
				setImageFile(split[1])
			})
			.catch((err) => {
				console.log(err)
			})

		setImageArray([
			{
				file: file,
				cover: URL.createObjectURL(file),
				key: ImageArray.length,
			},
		])
	}

	const uploadFileHandler = () => {
		const formData = new FormData()
		formData.append('file', ImageArray[0].file)
		formData.append('image', ImageArray[0].file)
		formData.append('upload_preset', 'feemfundy')
		formData.append('cloud_name', 'neutrinookoye')

		setUploading(true)

		fetch('https://api.cloudinary.com/v1_1/neutrinookoye/image/upload', {
			method: 'POST',
			body: formData,
		})
			.then((res) => res.json())
			.then((data) => {
				setUploading(false)
				// setMainImage(null)
				setUploadedImage(data.url)
				setImageFile('')
			})
			.catch((err) => {
				console.log(err)
				setUploading(false)
				// setMainImage(null)
				setImageFile('')
			})
	}

	const uploadFileHandler2 = async (e) => {
		const file = e.target.files[0] //When uploading, we have access to an array of files. But since we're
		//uploading a single file, it's only the first index iin the array we need.
		console.log(file)
		const formData = new FormData()
		formData.append('file', file)
		setFormD(formData)
		console.log(formD)
		setScriptUploading(true)

		try {
			const config = {
				headers: {
					'Content-Type': undefined,
					// 'Content-Type': 'multipart/form-data',
				},
			}

			const { data } = await axios.post(
				'https://feemfundy.herokuapp.com/api/upload/pdf',
				formData,
				config
			)

			setScript(data)

			setScriptUploading(false)
			console.log('done')
		} catch (error) {
			console.log(error)
			setScriptUploading(false)
		}
	}

	const submitHandler = (e) => {
		e.preventDefault()
		let data = {
			description,
			title,
			subTitle,
			genre,
			category,
			fundRound: submissionRound,
			userId: userDetail.id,
			email: userDetail.email,
			rewards,
			video,
			location,
			script,
			image: uploadedImage,
			askingAmount,
			accountName,
			accountNumber,
			bank,
		}
		if (
			description !== '' &&
			title !== '' &&
			category !== '' &&
			submissionRound !== '' &&
			genre !== '' &&
			location !== '' &&
			uploadedImage !== '' &&
			askingAmount !== '' &&
			accountName !== '' &&
			accountNumber !== '' &&
			bank !== ''
		) {
			dispatch(create_submission(data))

			navigate('/user/dashboard/submissions')
		} else {
			setFeedback('Please fill out all fields before submission')
		}
	}

	useEffect(() => {
		dispatch(get_current_campaign_user())

		return () => {
			dispatch({ type: CREATE_SUBMISSION_RESET })
			dispatch({ type: GET_CURRENT_CAMPAIGN_RESET })
		}
	}, [dispatch, submission, formD])

	// useEffect(() => {
	// 	let result = []

	// 	if (currentCampaign) {
	// 		result = currentCampaign.filter((e) => {
	// 			return e._id === submissionRound
	// 		})
	// 		setVal(result[0].name)
	// 		console.log(result[0].name)
	// 	}
	// }, [submissionRound])

	return (
		<>
			<main className='user_dashboard'>
				<section>
					<div className='container'>
						<div className='row justify-content-center'>
							<div className='col-md-10 user_dashboard_profile_form'>
								<form onSubmit={submitHandler}>
									<Nav tabs>
										<NavItem>
											<NavLink
												className={classnames({
													active: activeTab === '1',
												})}
												onClick={() => {
													toggle('1')
												}}
											>
												<div>
													<ImProfile />
												</div>
												Basic
											</NavLink>
										</NavItem>
										<NavItem>
											<NavLink
												className={classnames({
													active: activeTab === '2',
												})}
												onClick={() => {
													toggle('2')
												}}
											>
												<div>
													<FaScroll />
												</div>
												Story
											</NavLink>
										</NavItem>
										<NavItem>
											<NavLink
												className={classnames({
													active: activeTab === '3',
												})}
												onClick={() => {
													toggle('3')
												}}
											>
												<div>
													<GiMoneyStack />
												</div>
												Bank Details
											</NavLink>
										</NavItem>
										<NavItem>
											<NavLink
												className={classnames({
													active: activeTab === '4',
												})}
												onClick={() => {
													toggle('4')
												}}
											>
												<div>
													<FaEye />
												</div>
												Preview
											</NavLink>
										</NavItem>
									</Nav>
									<TabContent activeTab={activeTab} className='pt-5'>
										<TabPane tabId='1'>
											<Row>
												<Col sm='12'>
													<div>
														<div>
															<label>
																Select Campaign
																<span
																	style={{
																		color: 'red',
																		paddingTop: '0px',
																		display: 'inline-block',
																		marginLeft: '4px',
																	}}
																>
																	*
																</span>
															</label>
															<select
																onChange={(e) =>
																	setSubmissionRound(e.target.value)
																}
																className='form-select'
															>
																<option value=''>-- select --</option>
																{currentCampaign &&
																	currentCampaign.map((e) => (
																		<option key={e._id} value={e._id}>
																			{e.name}
																		</option>
																	))}
															</select>
															<p>
																Select the campaign you are submitting for, if
																any.
															</p>
														</div>
														<div>
															<label>
																Title
																<span
																	style={{
																		color: 'red',
																		paddingTop: '0px',
																		display: 'inline-block',
																		marginLeft: '4px',
																	}}
																>
																	*
																</span>
															</label>
															<input
																type='text'
																onChange={(e) => setTitle(e.target.value)}
																className='form-control'
															/>
															<p>
																Write a clear, brief title to help people
																quickly understand your project.
															</p>
														</div>
														<div>
															<label> Subtitle </label>
															<input
																type='text'
																onChange={(e) => setSubTitle(e.target.value)}
																className='form-control'
															/>
															<p>
																Write a clear, brief subtitle to help people
																quickly understand your project.
															</p>
														</div>
														<div>
															<label>
																Select Category
																<span
																	style={{
																		color: 'red',
																		paddingTop: '0px',
																		display: 'inline-block',
																		marginLeft: '4px',
																	}}
																>
																	*
																</span>
															</label>
															<select
																onChange={(e) => setCategory(e.target.value)}
																className='form-select'
															>
																<option value=''> -- select -- </option>
																<option value='Short Movies'>
																	Short Movies
																</option>
																<option value='Documentary'>Documentary</option>
															</select>
															<p>
																Select the category you are submitting for, if
																any.
															</p>
														</div>
														<div>
															<label>
																Select Genre
																<span
																	style={{
																		color: 'red',
																		paddingTop: '0px',
																		display: 'inline-block',
																		marginLeft: '4px',
																	}}
																>
																	*
																</span>
															</label>
															<select
																onChange={(e) => setGenre(e.target.value)}
																className='form-select'
															>
																<option value=''> -- select -- </option>
																<option value='Action'>Action</option>
																<option value='Comedy'>Comedy</option>
															</select>
															<p>
																Select the genre you are submitting for, if any.
															</p>
														</div>
														<div>
															<label>
																Location
																<span
																	style={{
																		color: 'red',
																		paddingTop: '0px',
																		display: 'inline-block',
																		marginLeft: '4px',
																	}}
																>
																	*
																</span>
															</label>
															<div>
																<Select
																	options={options}
																	value={locationArray}
																	onChange={changeHandler}
																/>
															</div>
															<p>
																Enter the location that best describes where
																your project is based.
															</p>
														</div>
														<div>
															<label>
																Funding Amount
																<span
																	style={{
																		color: 'red',
																		paddingTop: '0px',
																		display: 'inline-block',
																		marginLeft: '4px',
																	}}
																>
																	*
																</span>
															</label>
															<div className='d-flex'>
																<span className='currency form-control'>
																	&#8358;
																</span>
																<input
																	type='text'
																	onChange={(e) =>
																		setAskingAmount(e.target.value)
																	}
																	className='form-control curr_amt'
																/>
															</div>
															<p>
																Write an achievable amount that covers what you
																need to complete your project.
															</p>
														</div>
														<div className='d-flex justify-content-between'>
															<div></div>
															<button
																className='btn btn-danger'
																onClick={(e) => {
																	e.preventDefault()
																	toggle('2')
																}}
															>
																Next
															</button>
														</div>
													</div>
												</Col>
											</Row>
										</TabPane>
										<TabPane tabId='2'>
											<Row>
												<Col sm='12'>
													<div>
														<label htmlFor=''>
															Project Image
															<span
																style={{
																	color: 'red',
																	paddingTop: '0px',
																	display: 'inline-block',
																	marginLeft: '4px',
																}}
															>
																*
															</span>
														</label>
														<Dropper
															setFile={(file) => _setFile1(file)}
															caption={
																<div
																	style={{
																		height: '156px',
																		paddingTop: '3rem',
																	}}
																>
																	<p>
																		Drag 'n' drop some files here, or click to
																		select files
																	</p>
																	<span
																		className='d-flex justify-content-center align-items-center'
																		style={{
																			height: '40px',
																			cursor: 'pointer',
																		}}
																	>
																		<BsPlusSquare size={30} />
																	</span>
																</div>
															}
															imageArray={ImageArray}
															accept='image/*'
															upload={() => uploadFileHandler()}
														/>
														{imageFile && (
															<div className='col-md-12'>
																<div className='mt-2'>
																	<button
																		className='btn btn-primary'
																		onClick={uploadFileHandler}
																		disabled={uploading ? true : false}
																	>
																		{uploading ? (
																			<i className='fas fa-spinner fa-spin'></i>
																		) : (
																			<span>Upload Image</span>
																		)}
																	</button>
																</div>
															</div>
														)}
														<input
															type='text'
															value={uploadedImage}
															onChange={(e) => setUploadedImage(e.target.value)}
															className='site-form mb-3 d-none'
														/>
													</div>
													<div className='mt-3'>
														<label> Video </label>
														<input
															type='text'
															onChange={(e) => setVideo(e.target.value)}
															className='form-control'
														/>
														<p>Please append a link to the video.</p>
													</div>
													<div>
														<label> Project Script </label>
														<input
															type='file'
															onChange={uploadFileHandler2}
															className='form-control'
														/>
														{scriptUploading ? (
															<i className='fas fa-spinner'></i>
														) : null}
													</div>

													{/* <div className='mt-1'>
														<label htmlFor=''> Project Script (optional)</label>
														<Dropper
															setFile={(file) => _setFile2(file)}
															caption={
																<div
																	style={{
																		height: '156px',
																		paddingTop: '4rem',
																	}}
																>
																	<p>
																		Drag 'n' drop some files here, or click to
																		select files
																	</p>
																	<span
																		className='d-flex justify-content-center align-items-center'
																		style={{
																			height: '56px',
																			cursor: 'pointer',
																		}}
																	>
																		<BsPlusSquare size={50} />
																	</span>
																</div>
															}
															imageArray={ImageArray2}
															accept=''
															upload={() => uploadFileHandler2()}
														/>
														{videoFile && (
															<div className='col-md-12'>
																<div className='mt-2'>
																	<button
																		className='btn btn-primary'
																		onClick={uploadFileHandler2}
																		disabled={videoUploading ? true : false}
																	>
																		{videoUploading ? (
																			<i className='fas fa-spinner fa-spin'></i>
																		) : (
																			<span>Upload Script</span>
																		)}
																	</button>
																</div>
															</div>
														)}
														<input
															type='text'
															value={uploadedVideo}
															onChange={(e) => setUploadedVideo(e.target.value)}
															className='site-form mb-3 d-none'
														/>
													</div> */}
													<div className='mt-3'>
														<label htmlFor=''>
															Project Description
															<span
																style={{
																	color: 'red',
																	paddingTop: '0px',
																	display: 'inline-block',
																	marginLeft: '4px',
																}}
															>
																*
															</span>
														</label>
														<textarea
															cols='30'
															rows='7'
															className='form-control'
															required
															onChange={(e) => setDescription(e.target.value)}
															maxLength='350'
														></textarea>
														<p> {description.length} out of 350 </p>
													</div>
													<div>
														<label htmlFor='' className='d-none'>
															Rewards
														</label>
														<input
															type='hidden'
															className='form-control'
															onChange={(e) => setRewards(e.target.value)}
														/>
													</div>

													<div className='d-flex justify-content-between'>
														<button
															className='btn btn-danger'
															onClick={(e) => {
																e.preventDefault()
																toggle('1')
															}}
														>
															Back
														</button>
														<button
															className='btn btn-danger'
															onClick={(e) => {
																e.preventDefault()
																toggle('3')
															}}
														>
															Next
														</button>
													</div>
												</Col>
											</Row>
										</TabPane>
										<TabPane tabId='3'>
											<Row>
												<Col sm='12'>
													<div>
														<label htmlFor=''>Contact Email</label>
														<input
															type='email'
															disabled
															value={userDetail && userDetail.email}
															className='form-control'
														/>
													</div>
													<div>
														<label htmlFor=''>
															Bank
															<span
																style={{
																	color: 'red',
																	paddingTop: '0px',
																	display: 'inline-block',
																	marginLeft: '4px',
																}}
															>
																*
															</span>
														</label>
														<input
															type='text'
															className='form-control'
															onChange={(e) => setBank(e.target.value)}
														/>
													</div>
													<div>
														<label htmlFor=''>
															Account Number
															<span
																style={{
																	color: 'red',
																	paddingTop: '0px',
																	display: 'inline-block',
																	marginLeft: '4px',
																}}
															>
																*
															</span>
														</label>
														<input
															type='text'
															className='form-control'
															onChange={(e) => setAccountNumber(e.target.value)}
														/>
													</div>
													<div>
														<label htmlFor=''>
															Account Name
															<span
																style={{
																	color: 'red',
																	paddingTop: '0px',
																	display: 'inline-block',
																	marginLeft: '4px',
																}}
															>
																*
															</span>
														</label>
														<input
															type='text'
															className='form-control'
															onChange={(e) => setAccountName(e.target.value)}
														/>
													</div>

													<div className='d-flex justify-content-between'>
														<button
															className='btn btn-danger'
															onClick={(e) => {
																e.preventDefault()
																toggle('2')
															}}
														>
															Back
														</button>
														<button
															className='btn btn-danger'
															onClick={(e) => {
																e.preventDefault()
																toggle('4')
															}}
														>
															Next
														</button>
													</div>
												</Col>
											</Row>
										</TabPane>
										<TabPane tabId='4'>
											<div className='preview_box'>
												<h5>Title:</h5>
												<h6> {title} </h6>
											</div>
											<div className='preview_box'>
												<h5>Sub-Title:</h5>
												<h6> {subTitle} </h6>
											</div>
											<div className='preview_box'>
												<h5>Description:</h5>
												<div
													style={{
														display: 'flex',
														flexDirection: 'row',
														flexWrap: 'wrap-reverse',
													}}
												>
													<h6>{description}</h6>
												</div>
											</div>
											<div className='preview_box'>
												<h5>Category:</h5>
												<h6> {category} </h6>
											</div>
											<div className='preview_box'>
												<h5>Campaign:</h5>
												<h6> {submissionRound} </h6>
												{/* <h6> {submissionRound !== '' && 'selected'} </h6> */}
											</div>
											<div className='preview_box'>
												<h5>Rewards:</h5>
												<h6> {rewards} </h6>
											</div>
											<div className='preview_box'>
												<h5>Location:</h5>
												<h6> {location} </h6>
											</div>
											<div className='preview_box'>
												<h5>Bank:</h5>
												<h6> {bank} </h6>
											</div>
											<div className='preview_box'>
												<h5>Account Name:</h5>
												<h6> {accountName} </h6>
											</div>
											<div className='preview_box'>
												<h5>Account Number:</h5>
												<h6> {accountNumber} </h6>
											</div>
											<div className='preview_box'>
												<h5>Image:</h5>
												{ImageArray && ImageArray.length !== 0 && (
													<img
														src={ImageArray[0].cover}
														alt=''
														style={{ width: '30%' }}
													/>
												)}
											</div>
											<div className='preview_box'>
												<h5>Video:</h5>
												<h6> {video} </h6>
											</div>
											<div className='preview_box'>
												<h5>Project Script:</h5>
												<h6> {script} </h6>
											</div>
											<div className='d-flex justify-content-between mt-5'>
												<button
													className='btn btn-danger'
													onClick={(e) => {
														e.preventDefault()
														toggle('1')
													}}
												>
													Back
												</button>
												<div>
													<button
														type='submit'
														className='btn btn-secondary form-control'
													>
														{loadingCreate ? (
															<i className='fas fa-spinner'></i>
														) : (
															'Create'
														)}
													</button>
												</div>
											</div>
											<p className='mt-3'> {feedback} </p>
										</TabPane>
									</TabContent>
								</form>
							</div>
						</div>
					</div>
				</section>
			</main>
		</>
	)
}

export default UserDashboardNewSubmission
